import React from 'react';
import SlokaArtImage from '../SlokaArtImage';
import { MOBILE_PLAYER_QUERY, useMediaQuery } from '../../hooks/useMediaQuery';

const ListenVerseStage = ({
  track,
  artPaneClassName = '',
  wideMeaning = false,
  streamWideMeaning = false,
  children
}) => {
  const isMobile = useMediaQuery(MOBILE_PLAYER_QUERY);

  if (!track) return null;

  const verseKey = `${track.chapterNumber}-${track.slokaNumber}`;
  const useWideMeaning = (wideMeaning || streamWideMeaning) && !isMobile;
  const childrenArray = React.Children.toArray(children);
  const infoBlock = childrenArray[0] ?? null;
  const lyricsBlock = childrenArray.slice(1);

  const artPane = (extraClassName = '') => (
    <div className={`listen-sloka-art-pane ${artPaneClassName} ${extraClassName}`.trim()}>
      <p className="listen-sloka-art-label">Verse illustration</p>
      <div className="listen-verse-art-card" key={verseKey}>
        <div className="listen-sloka-art-frame">
          <SlokaArtImage
            chapterNumber={track.chapterNumber}
            slokaNumber={track.slokaNumber}
            alt={`Chapter ${track.chapterNumber}, Verse ${track.slokaNumber}`}
            className="listen-sloka-art"
          />
        </div>
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <div className="listen-player-split listen-player-split--mobile-stack">
        {infoBlock}
        {artPane(`listen-sloka-art-pane--mobile ${artPaneClassName}`.trim())}
        <div className="listen-lyrics-area">{lyricsBlock}</div>
      </div>
    );
  }

  if (!useWideMeaning) {
    return (
      <div className="listen-player-split">
        <div className="listen-player-main spotify-stage-main">{children}</div>
        {artPane()}
      </div>
    );
  }

  return (
    <div
      className={`listen-player-split listen-player-split--wide-meaning ${streamWideMeaning ? 'listen-player-split--stream-wide' : ''}`}
    >
      <div className="listen-player-main listen-player-main--wide spotify-stage-main">
        {infoBlock}
        <div className="listen-lyrics-area">{lyricsBlock}</div>
      </div>
      {artPane(`listen-sloka-art-pane--desktop ${artPaneClassName}`.trim())}
    </div>
  );
};

export default ListenVerseStage;
